// extracted by mini-css-extract-plugin
export default {"container":"ActivationHeader_container__HzzO0","buttons":"ActivationHeader_buttons__w5f-5"};